import { reduxKey } from './constants';
import get from 'lodash/get';
import { createSelector } from 'reselect';

const getWatchSlice = state => state[reduxKey];

export const getWatchState = createSelector(
  getWatchSlice,
  (state, username) => username,
  (state, username) => {
    return username ? state[username.toLowerCase()] : {};
  }
);

export function getIsInitialized(state, username: string): boolean {
  return (
    Boolean(username) &&
    state[reduxKey] !== undefined &&
    state[reduxKey][username.toLowerCase()] !== undefined
  );
}

export const getUserWatchState = createSelector(
  state => state,
  (state, user) => user,
  (state, initialState) => initialState,
  (state, user, initialState) => {
    const username = get(user, 'username');
    const initialIsWatching = initialState?.isWatching ?? get(user, 'isWatching') ?? false;
    if (!username) {
      return { isWatching: initialIsWatching, isLoading: false };
    }

    const userState = getWatchState(state, username);

    return {
      isWatching: initialIsWatching,
      isLoading: false,
      ...userState,
    };
  }
);
